import store, { ContactActions } from '@web-common/state/createStore';
import { api, apis, util } from 'api';
import { buildContactModel, transContactModel2MailContactModel } from '@web-common/utils/contact_util';
import debounce from 'lodash/debounce';
import lodashGet from 'lodash/get';
import { doGetCustomerContactByEmails, doUpdateContactMap, doUpdateLxContactMap, doUpdateEmailIdMap } from '@web-common/state/reducer/contactReducer';
import { createAccountEmailKey, getMainAccount } from '@web-common/components/util/contact';
import cloneDeep from 'lodash/cloneDeep';
const contactApi = api.requireLogicalApi(apis.contactApiImpl);
const systemApi = api.getSystemApi();
class ContactReduxApi {
    constructor() {
        this.requestEmails = new Map();
        this.requestIds = new Map();
        this.requestOrgIds = new Map();
        this.requestEmailNameMap = new Map();
        this.getEmailMarkedDetail = (params) => {
            var _a;
            const { email, _account = (_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id, orgId } = params;
            if (_account) {
                if (orgId) {
                    const orgIdSet = this.requestOrgIds.get(_account) || new Set();
                    orgIdSet.add(orgId);
                    this.requestOrgIds.set(_account, orgIdSet);
                    this.requestMarkedDetail();
                }
                else if (email) {
                    const emailSet = this.requestEmails.get(_account) || new Set();
                    emailSet.add(email);
                    this.requestEmails.set(_account, emailSet);
                    this.requestMarkedDetail();
                }
            }
        };
        this.requestMarkedDetail = debounce(() => {
            const requestEmails = this.requestEmails;
            const requestOrgIds = this.requestOrgIds;
            requestEmails.forEach(async (emailSet, _account) => {
                const dispatch = store.dispatch;
                if (emailSet.size) {
                    const emails = [...emailSet];
                    console.log('[requestMarkedDetail] emails', emails, _account);
                    const mapData = await contactApi.doGetPersonalMarklistByEmail({ emails, _account });
                    console.log('[requestMarkedDetail] emails result', mapData);
                    const payload = new Map();
                    const accountSet = requestEmails.get(_account) || new Set();
                    emails.forEach(email => {
                        accountSet.delete(email);
                        const markedList = mapData.get(email);
                        if (markedList) {
                            const contactIdList = [];
                            markedList.forEach(item => {
                                const contactId = item.value;
                                if (contactId) {
                                    contactIdList.push(item.value);
                                }
                            });
                            payload.set(email, contactIdList);
                        }
                        else {
                            payload.set(email, []);
                        }
                    });
                    requestEmails.set(_account, accountSet);
                    dispatch(ContactActions.doUpdateEmailMarkedMap({ data: payload, type: 'add', isAll: true }));
                }
            });
            requestOrgIds.forEach(async (orgIdSet, _account) => {
                const dispatch = store.dispatch;
                if (orgIdSet.size) {
                    const orgIds = [...orgIdSet];
                    console.log('[requestMarkedDetail] orgIds', orgIds, _account);
                    const list = await contactApi.doGetPersonalMarkList(orgIds, 'value');
                    const orgSet = new Set();
                    list.forEach(item => {
                        const orgId = item.value;
                        if (item.type === 2 && orgId) {
                            orgSet.add(orgId);
                        }
                    });
                    console.log('[requestMarkedDetail] orgIds result', list);
                    const accountSet = requestEmails.get(_account) || new Set();
                    const payload = new Map();
                    orgIds.forEach(orgId => {
                        accountSet.delete(orgId);
                        payload.set(orgId, orgSet.has(orgId));
                    });
                    requestEmails.set(_account, accountSet);
                    dispatch(ContactActions.doUpdateOrgMarkedMap(payload));
                }
            });
        }, 1000, { leading: true });
    }
}
const requestContactDataByEmails = async (emails, _account) => {
    const res = await contactApi.doGetContactByEmailFilter({ emails, _account });
    const updateEmailIdMap = {};
    const updateContactList = [];
    emails.forEach(email => {
        const current = res[email];
        if (current) {
            const accountEmailKey = createAccountEmailKey(email, _account);
            updateEmailIdMap[accountEmailKey] = current.contact.id;
            updateContactList.push(current);
        }
    });
    return { updateContactList, updateEmailIdMap };
};
export const doGetEmailMarkedData = new ContactReduxApi().getEmailMarkedDetail;
export const doGetContactData = (() => {
    const requestEmails = new Map();
    const requestIds = new Map();
    const requestOrgIds = new Map();
    const requestEmailNameMap = new Map();
    const search = debounce(async () => {
        const dispatch = store.dispatch;
        requestEmails.forEach(async (emailSet, _account) => {
            if (emailSet.size) {
                const emails = [...emailSet];
                const emailNameMap = requestEmailNameMap.get(_account);
                console.log('[doGetContactData] emails', emails, _account);
                const { updateContactList, updateEmailIdMap } = await requestContactDataByEmails(emails, _account);
                console.log('[doGetContactData] emails result', updateContactList);
                const resEmails = new Set();
                const contactList = [];
                updateContactList.forEach(item => {
                    if (item) {
                        item._account = _account;
                        contactList.push(item);
                        resEmails.add(item.contact.displayEmail);
                        resEmails.add(item.contact.accountName);
                    }
                });
                const accountSet = requestEmails.get(_account) || new Set();
                const externalList = [];
                const reduxUpdateTime = Date.now();
                emails.forEach(e => {
                    accountSet.delete(e);
                    if (!resEmails.has(e) && !resEmails.has(e.toLocaleLowerCase())) {
                        const externalName = (emailNameMap === null || emailNameMap === void 0 ? void 0 : emailNameMap.get(e)) || e;
                        const externalId = 'external_id_' + e;
                        const contactModelItem = buildContactModel({ email: e, type: 'external', name: externalName, id: externalId }, { isFull: true, _account, reduxUpdateTime });
                        externalList.push(contactModelItem);
                        const accountEmailKey = createAccountEmailKey(e, _account);
                        updateEmailIdMap[accountEmailKey] = externalId;
                    }
                });
                requestEmails.set(_account, accountSet);
                doUpdateEmailIdMap(updateEmailIdMap);
                doUpdateContactMap({ [_account]: [...contactList, ...externalList] });
            }
        });
        requestIds.forEach(async (idSet, _account) => {
            if (idSet.size) {
                const idList = [...idSet];
                console.log('[doGetContactData] ids lx', idList, _account);
                const updateList = await contactApi.doGetContactById(idList, _account);
                const lxIdList = new Set();
                updateList.forEach(item => {
                    lxIdList.add(item.contact.id);
                });
                if (updateList === null || updateList === void 0 ? void 0 : updateList.length) {
                    console.log('[doGetContactData] ids result', updateList);
                    const accountSet = requestIds.get(_account) || new Set();
                    const errorIds = [];
                    idList.forEach(id => {
                        accountSet.delete(id);
                        if (!lxIdList.has(id)) {
                            errorIds.push(id);
                        }
                    });
                    if (errorIds === null || errorIds === void 0 ? void 0 : errorIds.length) {
                        console.error('[doGetContactData] request ids error', errorIds);
                    }
                    requestIds.set(_account, accountSet);
                    doUpdateLxContactMap({ [_account]: updateList });
                }
            }
        });
        requestOrgIds.forEach(async (idSet, _account) => {
            if (idSet.size) {
                const idList = [...idSet];
                console.log('[doGetContactData] orgIds', idList, _account);
                const orgData = await contactApi.doGetOrgList({ idList, _account });
                if (orgData === null || orgData === void 0 ? void 0 : orgData.length) {
                    dispatch(ContactActions.doUpdateOrgMap(orgData));
                    const accountSet = requestOrgIds.get(_account) || new Set();
                    idList.forEach(e => {
                        accountSet.delete(e);
                    });
                    requestOrgIds.set(_account, accountSet);
                }
            }
        });
    }, 1000, { leading: true });
    return (params) => {
        var _a;
        const { email, contactId, useIdFirst, _account = (_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id, personalOrg, name } = params;
        if (email || contactId || personalOrg) {
            if (_account) {
                if (useIdFirst && contactId) {
                    const idSet = requestIds.get(_account) || new Set();
                    idSet.add(contactId);
                    requestIds.set(_account, idSet);
                }
                else if (email) {
                    const emailSet = requestEmails.get(_account) || new Set();
                    const emailNameMap = requestEmailNameMap.get(_account) || new Map();
                    emailSet.add(email);
                    if (!emailNameMap.has(email)) {
                        emailNameMap.set(email, name);
                    }
                    requestEmails.set(_account, emailSet);
                    requestEmailNameMap.set(_account, emailNameMap);
                }
                else if (contactId) {
                    const idSet = requestIds.get(_account) || new Set();
                    idSet.add(contactId);
                    requestIds.set(_account, idSet);
                }
                else if (personalOrg === null || personalOrg === void 0 ? void 0 : personalOrg.length) {
                    const idSet = requestOrgIds.get(_account) || new Set();
                    requestOrgIds.set(_account, new Set([...idSet, ...personalOrg]));
                }
            }
            search();
        }
    };
})();
export const doGetConactDataFromServer = async (id, email, _account = getMainAccount()) => {
    const list = await contactApi.doGetContactByQiyeAccountId({
        idList: [id],
        _account,
    });
    if (Array.isArray(list) && list.length) {
        const accountEmailKey = createAccountEmailKey(email, _account);
        doUpdateEmailIdMap({ [accountEmailKey]: id });
        doUpdateLxContactMap({
            [_account]: list.map(item => {
                item.isFull = true;
                return item;
            }),
        });
    }
};
export const doMergeContactDataWithServerData = (() => {
    const requestModelMap = new Map();
    const search = debounce(() => {
        if (!requestModelMap.size) {
            return;
        }
        contactApi
            .doGetContactByQiyeAccountId({
            idList: [...requestModelMap.keys()],
        })
            .then(serverModels => {
            const serverModelMap = new Map(serverModels.map(item => {
                var _a;
                return [((_a = item === null || item === void 0 ? void 0 : item.contact) === null || _a === void 0 ? void 0 : _a.id) || '', item];
            }));
            const mergedContactModelList = [...requestModelMap.keys()].map(key => {
                const requestModel = requestModelMap.get(key);
                if (!serverModelMap.has(key)) {
                    return requestModel;
                }
                const serverModel = serverModelMap.get(key);
                if (!serverModel.contact.avatar) {
                    serverModel.contact.avatar = requestModel.contact.avatar;
                }
                if (!serverModel.contact.position || serverModel.contact.position.length === 0) {
                    serverModel.contact.position = requestModel.contact.position;
                }
                return serverModel;
            });
            doUpdateLxContactMap(mergedContactModelList);
            requestModelMap.clear();
        })
            .catch(ex => {
            console.error('[contact.redux]doGetContactDataFromServer.error', ex);
            requestModelMap.clear();
        });
    }, 500, { leading: true });
    return (params) => {
        var _a, _b;
        const { contactModel, requiredField, _account = (_a = systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id } = params;
        const contactType = lodashGet(contactModel, 'contact.type', '');
        if (!Array.isArray(params.requiredField) || !requiredField.length || contactType !== 'enterprise') {
            return;
        }
        if (_account !== ((_b = systemApi.getCurrentUser()) === null || _b === void 0 ? void 0 : _b.id)) {
            return;
        }
        const needSync = requiredField.some(itemField => {
            return typeof lodashGet(contactModel, `contact.${itemField}`, undefined) === 'undefined';
        });
        if (!needSync) {
            return;
        }
        requestModelMap.set(lodashGet(contactModel, 'contact.id', ''), contactModel);
        search();
    };
})();
export const doGetContactListById = async (idList) => {
    const state = store.getState();
    const result = new Map();
    const contactMap = state.contactReducer.contactMap;
    const dbIdList = [];
    idList.forEach(id => {
        if (contactMap[id]) {
            result.set(id, contactMap[id]);
        }
        else {
            dbIdList.push(id);
        }
    });
    if (dbIdList.length) {
        const contactList = await contactApi.doGetContactById(dbIdList);
        contactList.forEach(item => {
            result.set(item.contact.id, item);
        });
    }
    return [...result.values()];
};
export const doGetContactModelByContactItem = async (list, options) => {
    const useEmail = (options === null || options === void 0 ? void 0 : options.useEmail) || true;
    const useCompositeQuery4Lx = options === null || options === void 0 ? void 0 : options.useCompositeQuery4Lx;
    const _account = (options === null || options === void 0 ? void 0 : options._account) || '';
    const state = store.getState();
    const result = new Map();
    const { contactMap, emailIdMap } = state.contactReducer;
    const idMap = new Map();
    const emailList = [];
    const customerList = [];
    const customerEmailList = [];
    const externalEmailData = new Map();
    list.forEach(item => {
        const { email, id, type } = item;
        let flag = false;
        if (id && !contactMap[id]) {
            if (type === 'customer' || type === 'clue') {
                customerList.push(item);
            }
            else {
                idMap.set(id, item);
            }
        }
        const _useCompositeQuery4Lx = useCompositeQuery4Lx && ['personal', 'enterprise'].includes(type) && id;
        if (useEmail && email && !_useCompositeQuery4Lx) {
            const contactId = emailIdMap[email];
            if (!flag && contactId) {
                const model = contactMap[contactId];
                if (model) {
                    flag = true;
                    const { contact, contactInfo } = model;
                    if (type === 'personal') {
                        result.set(util.getUnique(contact.id, email), { contact: Object.assign(Object.assign({}, contact), { hitQueryEmail: email }), contactInfo });
                    }
                    else {
                        result.set(contact.id, model);
                    }
                }
            }
            if (!flag && email) {
                if (type === 'customer' || type === 'clue') {
                    customerEmailList.push(email);
                    externalEmailData.set(email, item);
                }
                else {
                    emailList.push(email);
                    externalEmailData.set(email, item);
                }
            }
        }
        else {
            if (id && contactMap[id]) {
                flag = true;
                const model = contactMap[id];
                const { contact, contactInfo } = model;
                if (type === 'personal') {
                    const contactCopy = cloneDeep({ contact: Object.assign(Object.assign({}, contact), { hitQueryEmail: email }), contactInfo });
                    result.set(util.getUnique(id, email), contactCopy);
                }
                else {
                    result.set(id, model);
                }
            }
            if (!flag && id) {
                if (type === 'customer' || type === 'clue') {
                    customerList.push(item);
                }
                else {
                    idMap.set(id, item);
                }
                if (_useCompositeQuery4Lx) {
                    externalEmailData.set(email, item);
                }
            }
        }
    });
    if (idMap.size) {
        const contactList = await contactApi.doGetContactById([...idMap.keys()], _account);
        contactList.forEach(item => {
            const { contact, contactInfo } = item;
            const originItem = idMap.get(contact.id);
            if (originItem) {
                externalEmailData.delete(contact.accountName);
                if (originItem.type === 'personal') {
                    result.set(util.getUnique(contact.id, originItem.email), { contact: Object.assign(Object.assign({}, contact), { hitQueryEmail: originItem.email }), contactInfo });
                }
                else if (originItem.type === 'enterprise') {
                    result.set(contact.id, item);
                }
            }
        });
    }
    if (customerList.length) {
        customerList.forEach(item => {
            if (item.id) {
                result.set(item.id, buildContactModel(item));
            }
        });
    }
    if (customerEmailList.length) {
        const res = await doGetCustomerContactByEmails({ emails: customerEmailList });
        Object.values(res).forEach(model => {
            result.set(model.contact.id, model);
            externalEmailData.delete(model.contact.accountName);
        });
    }
    if (emailList.length) {
        const contactRes = await contactApi.doGetContactByEmailsAdvance({ emails: emailList, useEdm: false, _account: options === null || options === void 0 ? void 0 : options._account });
        contactRes.listRes.forEach(item => {
            const { contact: { id, type, hitQueryEmail, accountName }, } = item;
            externalEmailData.delete(accountName);
            if (type === 'personal') {
                result.set(util.getUnique(id, hitQueryEmail), item);
            }
            else if (type === 'enterprise') {
                result.set(id, item);
            }
        });
    }
    const externalData = [];
    if (externalEmailData.size) {
        externalEmailData.forEach(item => {
            externalData.push(buildContactModel(item));
        });
    }
    return [...result.values(), ...externalData];
};
export const doGetMailContactModelByContactItem = async (list, receiverType, _account) => {
    let model = [];
    if (list.length) {
        model = await doGetContactModelByContactItem(list, {
            useCompositeQuery4Lx: true,
            _account: _account,
        });
    }
    const modelMap = {};
    model.forEach(item => {
        const mailModel = transContactModel2MailContactModel(item, receiverType);
        const displayEmail = contactApi.doGetModelDisplayEmail(item);
        if (displayEmail && mailModel) {
            modelMap[displayEmail] = mailModel;
        }
    });
    const receiver = [];
    list.forEach(item => {
        const model = modelMap[item.email];
        if (model) {
            receiver.push(model);
        }
        else {
            console.error('doGetMailContactModelByContactItem has error', item, modelMap);
        }
    });
    return receiver;
};
